import { z, ZodObject } from 'zod';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { IANA_TIMEZONE_LIST } from '@/constants/date.constants';

const phoneUtil = PhoneNumberUtil.getInstance();

export const TIMEZONE_SCHEMA = z.enum(IANA_TIMEZONE_LIST, { error: 'Select timezone' });

export const STATE_SCHEMA = z.string().nullable();

export const COUNTRY_SCHEMA = z.string().min(1, 'Select country');

const createPhoneSchema = (isRequired: boolean) =>
  z.string().refine(
    (val) => {
      if (!isRequired && !val) return true;
      try {
        const parsed = phoneUtil.parse(val);
        return phoneUtil.isPossibleNumber(parsed);
      } catch {
        return false;
      }
    },
    { error: 'Invalid phone number' },
  );

type PhoneSchemaType<T> = T extends true
  ? ReturnType<typeof createPhoneSchema>
  : ReturnType<ReturnType<typeof createPhoneSchema>['optional']>;

export const getPhoneSchema = <T extends boolean = true>({ isRequired }: { isRequired: T }): PhoneSchemaType<T> => {
  const schema = createPhoneSchema(isRequired);

  if (!isRequired) {
    return schema.optional() as PhoneSchemaType<T>;
  }

  return schema as PhoneSchemaType<T>;
};

export const isFieldRequired = (schema: z.ZodType, fieldName: string): boolean => {
  if (schema instanceof ZodObject) {
    const field = schema.shape[fieldName];

    return !field?.isOptional();
  }

  return false;
};
